"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var operators_1 = require("rxjs/operators");
function notNil(a) {
    return !lodash_1.isNil(a);
}
exports.notNil = notNil;
/**
 * throws 'error' if value is not allowed by the `predicate` function
 * @param  predicate - predicate function
 * @param  error     - error or error supplier
 * @return UnaryFunction
 */
function assert(predicate, error) {
    return operators_1.map(function (value) {
        if (!predicate(value)) {
            if (error instanceof Error) {
                throw error;
            }
            else {
                throw error(value);
            }
        }
        return value;
    });
}
exports.assert = assert;
//# sourceMappingURL=common.utilities.js.map